import ComplaintMobileActions from './ComplaintMobileActions'

export default ComplaintMobileActions
